var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#FDE9E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 8H7C5.89543 8 5 8.89543 5 10V11.1111M5 11.1111V20C5 21.1046 5.89543 22 7 22H23C24.1046 22 25 21.1046 25 20V14M5 11.1111H20M6.92308 19.2H10.3846M11.9231 19.2H18.8462",
    stroke: "#364037",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 8V12M24 12L26 11M24 12L22 11",
    stroke: "#364037",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.bad0430656296df2cfc06302abced16b.svg";
export { ForwardRef as ReactComponent };